// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fk-0";
export var fulfillmentPanelBody = "_fk-1";